import { handleDeleteConfirmation } from 'Utils/handleDelete';
import { fetchCategoryProgram, deleteCategoryProgram } from 'Features/Learning/CategoryProgram/Utils/CategoryProgramUtils';

/* **************************************************** */
/* CRUD CategoryProgram                                       */
/* **************************************************** */

export const fetchCategory = (dispatch, filters, refetch) => {
  dispatch(fetchCategoryProgram(filters));
};

export const handleDeleteCategoryProgram = async (dispatch, id, setRefetch) => {
  handleDeleteConfirmation({
    dispatch,
    id,
    setRefetch,
    deleteAction: deleteCategoryProgram,
  });
};

export const handleEditCategoryProgram = async (dispatch, item, setField) => {
  if (!item) return;

  const fieldsToUpdate = ['name', 'slug'];
  fieldsToUpdate.forEach((field) => {
    dispatch(setField({ field, value: item[field] ?? '' }));
  });

  const newArrayChildren = (item.children || []).map((child) => ({
    id: child.id,
    name: child.name,
    slug: child.slug,
    parent_id: child.parent_id,
  }));

  dispatch(setField({
    field: 'children',
    value: newArrayChildren.length
      ? newArrayChildren
      : [{ name: '', slug: '', parent_id: item.id || 1 }],
  }));
  dispatch(setField({ field: 'isUpdate', value: true }));
  dispatch(setField({ field: 'id', value: item.id }));
};

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page > 1) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page - 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page < pagination.last_page) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page + 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
  dispatch(setFilters({
    ...filters,
    page: page
  }));
  setRefetch(prevRefetch => !prevRefetch);
}